<template>
	<div class="box">
		<ul class="tableHeader tableHeaderbox">
			<li v-for="item in tableList">{{item.tableName}}</li>
		</ul>
		<!-- -->
		<div class="tabletd"  @scroll="scrollEvent($event)">
			<ul class="tablecontent tableHeader " v-for="item in datalist">
				<li><p>{{item.cName}}</p></li>
				<li><p>{{arrFn(item.cFullName)}}</p></li>
				<li><p>{{item.cAddr}}</p></li>
				<li>{{item.cCpyTel}}</li>
				<li>
					<p @click="yyxkImgFn(item.cImgA)"><i class="el-icon-search"></i>营业许可证</p>
					<p @click="yyzzImgFn(item.cImgB)"><i class="el-icon-search"></i>营业执照</p>
				</li>
				<li>{{item.cPerson}}</li>
				<li>{{item.cTel}}</li>
				<li>
					<div class="btn">
						<button @click="renzheng_companyFn(item.id,item.cTel,item.cPerson)" :disabled="tongguo">通过</button>
					</div>
					<div class="btn">
						<button @click="adduserFn(item.id,item.cTel,item.cPerson)" :disabled="tongguo">驳回</button>
					</div>
					<!--<button @click="yuyueBool=true">补录</button>-->
				</li>
			</ul>
			<div class="list-more" v-show="deviceTip">
				<p>{{deviceTip}}</p>
			</div>
		</div>
		<el-dialog
		  title=""
		  :visible.sync="centerDialogVisible"
		  width="80%"
		  center>
		  <img style="text-align: center;" :src="DialogImg"/>
		  <span slot="footer" class="dialog-footer">
		    <!--<el-button @click="centerDialogVisible = false">取 消</el-button>-->
		    <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
		  </span>
		</el-dialog>
	</div>
	<!--
		/upload/2019-11-20/5dd4e3300a001.png  di
		/upload/2019-11-20/5dd4e34787e1b.png  dr
		/upload/2019-11-20/5dd4e30e0de7c.png  at
		
	-->
</template>

<script>
	import config from '../../http/config.js'
	import {company_list,renzheng_company,user_save} from '../../http/api.js'
	export default{
		components:{
		},
		data(){
			return{
				pageIndex:1,
				datalist:[],
				total: 0, //总条数
			    pageCount: 0, //总页数
			    isRequestData:true,
				tableData:null,
				jgfkBool:false,
				yuyueBool:false,
				tableList:[{
						tableName:'诊所名称',
					},{
						tableName:'地区',
					},{
						tableName:'详细地址',
					},{
						tableName:'联系电话',
					},{
						tableName:'认证材料',
					},{
						tableName:'管理者',
					},{
						tableName:'联系电话',
					},{
						tableName:'操作',
					}
				],
				ddBool:null,
				zlBool:null,
				ycBool:'',
				yc2Bool:'',
				devicePageSize: 10, //每页显示
			    devicePageNum: 1, //当前页
			    devicePageTotal: 0, //总条数
			    devicePageTotalPages: 0, //总页数
			    deviceListIsFinish: false, //是否加载完成
			    deviceListIsLoad: false, //是否加载更多
			    deviceListnodata: false, //是否有数据
			    deviceTip: "",
			    deviceList:[],
			    deviceRow:{},
			    yyxkImg:false,
			    yyzzImg:false,
			    tongguo:false,
			    DialogImg:'',
			    centerDialogVisible:false
				
			}
		},
		mounted(){
			this.company_listFn();
		},
		methods:{
			company_listFn () {
				let data = {
		      		page:this.devicePageNum,
      				limit:this.devicePageSize,
      				rz:2
		      	}
		      	company_list(data).then(res=>{
		      		if(res.result==0){
	      				this.devicePageTotal = res.total;
				        this.devicePageTotalPages=res.pagecount;
				        if(res.data==''){
				            this.deviceListnodata = true;
				            this.deviceListIsLoad = false;
				            this.deviceListIsFinish = true;
				            this.devicePageNum = 1;
				            this.deviceTip = "暂无数据";
				            return false;  	
				        }else{
				        	if(res.count<this.devicePageSize){
				        		this.deviceListnodata = true;
					            this.deviceListIsLoad = false;
					            this.deviceListIsFinish = true;
					            this.devicePageNum = 1;
					            this.deviceTip = "暂无数据";
//					            return false;  	
				        	}else{
					        	this.deviceListIsLoad = true;
					            this.deviceListIsFinish = false;
					            this.devicePageNum++;
					            this.deviceTip = "正在加载中~";
				        		
				        	}
				        }
				        this.datalist=this.datalist.concat(res.data);
	      			}else{
	      				this.deviceListIsLoad = false;
				        this.deviceListIsFinish = true;
				        this.devicePageNum = 1;
				        this.deviceTip = "数据加载失败~";
      				}
		      	});
			},
			arrFn(str){
				var arr=[]
				 arr = (str||"").split(',');
				 if(arr[1]==undefined){
				 	return "-"
				 }else{
				 	return arr[1]+'/'+arr[2]
				 }
			},
			scrollEvent (e) {
	    		if (e instanceof Event) {
		        	let el = e.target;
		        	let scrollTop = el.scrollTop;
			        // 获取可视区的高度
			        let clientHeight = el.clientHeight;
			        // 获取滚动条的总高度
			        let scrollHeight = el.scrollHeight;
			        let height = 140;//一格表格的高
			        if ( scrollTop + clientHeight >= scrollHeight&&this.deviceListIsLoad &&!this.deviceListIsFinish) {
			        this.deviceListIsLoad = true;
//			        console.log("到底了");
			        var timer=setTimeout(() => {
			         	this.company_listFn();
			         	clearTimeout(timer)
			        }, 1000);
		        	}
	   	 		}	
	   		},
	   		renzheng_companyFn(id,tel,name){
	   			var data={
	   				cpy_id:id,
	   				rz:1
	   			}
	   			renzheng_company(data).then(res=>{
	   				if(res.result==1){
						this.$message({
				            message:'操作成功',
				            type: 'success',
				            duration:1000,
				            onClose:()=>{
				            	this.datalist=[];
				            	this.devicePageSize= 10;//每页显示
		   						this.devicePageNum= 1;
				            	this.company_listFn();
   								this.tongguo=false;
				         	}
						})
					}else{
						this.$message({
				            message:'操作失败',
				            type: 'error',
				            duration:1000,
				            onClose:()=>{
   								this.tongguo=false;
				            	
				         	}
						})
					}
	   			})
	   		},
	   		bohui_companyFn(id,tel,name){
	   			var data={
	   				cpy_id:id,
	   				rz:2,
	   			}
	   			renzheng_company(data).then(res=>{
	   				if(res.result==1){
						this.$message({
				            message:'操作成功',
				            type: 'success',
				            duration:1000,
				            onClose:()=>{
				            	this.datalist=[];
				            	this.devicePageSize= 10;//每页显示
		   						this.devicePageNum= 1;
				            	this.company_listFn();
   								this.tongguo=false;
				         	}
						})
					}else{
						this.$message({
				            message:'操作失败',
				            type: 'error',
				            duration:1000,
				            onClose:()=>{
   								this.tongguo=false;
				            	
				         	}
						})
					}
	   			})
	   		},
	   		adduserFn(id,tel,name){
	   			 this.tongguo=true;
	   			 this.$prompt('请输入驳回原因', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		        }).then(({ value }) => {
	        		var data={
		   				cpy_id:id,
		   				rz:2,
		   				remark:value
		   			}
		   			renzheng_company(data).then(res=>{
		   				if(res.result==1){
							this.$message({
					            message:'操作成功',
					            type: 'success',
					            duration:1000,
					            onClose:()=>{
					            	this.datalist=[];
					            	this.devicePageSize= 10;//每页显示
			   						this.devicePageNum= 1;
					            	this.company_listFn();
	   								this.tongguo=false;
					         	}
							})
						}else{
							this.$message({
					            message:'操作失败',
					            type: 'error',
					            duration:1000,
					            onClose:()=>{
	   								this.tongguo=false;
					            	
					         	}
							})
						}
		   			})
		        }).catch(() => {
	            	this.tongguo=false;
		        });
	   			
	   		},
	   		getSex (sex){
				return sex == 1?'男':'女';
			},
			getTime(dt){
				let ay = dt.split(' ');
				return ay[0]+' '+ay[1].substr(0,5);
			},
			yyxkImgFn(str){
				if(str){
					this.centerDialogVisible=true;
					this.DialogImg=str;
				}else{
					this.$message({
		                message:"该诊所未上传营业许可证",
		                type: 'info',
		                duration:1000,
		                onClose:()=>{
		         		}
					})
				}
			},
			yyzzImgFn(str){
				if(str){
					this.centerDialogVisible=true;
					this.DialogImg=str;
				}else{
					this.$message({
		                message:"该诊所未上传营业执照",
		                type: 'info',
		                duration:1000,
		                onClose:()=>{
		         		}
					})
				}
			},
			imgCloseFn(){
				$('.dialogImg').hide();
				this.yyzzImg=false;
				this.yyxkImg=false;
			},
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
		position: relative;
	}
	.tableHeader{
		width: 100%;
		height: 20px;
		/*border-bottom: 1px solid #CCCCCC;*/
		background:#FFFFFF ;
	}
	.tableHeaderbox{
		padding-top: 50px;
		
	}
	.tabletd{
		/*position: absolute;
		top: 70px;
		left: 0;*/
		background:#F5F5F5 ;
		width: 100%;
		height: 720px;
		overflow: auto;
	}
	.tablecontent{
		width: 100%;
		height: 140px;
		border-bottom: 3px solid #FFFFFF;
		position: relative;
		background: #FDFBE5;
		
	}
	.tablecontent>li:nth-child(1){
		overflow: hidden;
	}
	/*.tablecontent::before{
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 1;
		background: #FEFDF7;
	}
	.tablecontent::after{
		content: "";
		display: block;
		position: absolute;
		bottom: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 1;
		background: #FEFDF7;
	}*/
	.tableHeader li ,.tablecontent li{
		float: left;
		text-align: center;
		font-size: 12px;
		color: #9B9B9B;
	}
	.tablecontent li{
		height: 140px;
		line-height: 140px;
		position: relative;
		color: #9B9B9B;
		/*z-index: 2;*/
		/*overflow: hidden;*/
	}
	.tablecontent li::before{
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 2px;
		height: 118px;
		border-left: 2px dashed #D7D9DC;/*px*/
	}
	.tablecontent li:nth-child(1){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	.tablecontent li:nth-child(1)>p{
		margin: 0 10px;
		word-wrap:break-word;
   		 word-break: break-all 
	}
	.tablecontent li:nth-child(2){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	.tablecontent li:nth-child(3){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	.tablecontent li:nth-child(2)>p,.tablecontent li:nth-child(3)>p{
		margin: 0 10px;
		word-wrap:break-word;
   		word-break: break-all 
	}
	.tablecontent li:nth-child(6){
		font-size:11px;
		font-family:"微软雅黑";
		font-weight:600;
		color:rgba(155,155,155,1);
	}
	.tablecontent li:nth-child(8)>div{
		width:80px;
		height:30px;
		margin-right:10px ;
	}
	.tablecontent li:nth-child(8)>div:hover button{
		border: 2px solid yellow;
	}
	.tablecontent li:nth-child(8) button:nth-child(1){
		float: left;
		width:80px;
		height:30px;
		background:#0078FF;
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		color: #FFFFFF;
		border: none;
		font-size: 11px;
		cursor: pointer;
	} 
	.tablecontent li:nth-child(8) button:nth-child(2){
		width:80px;
		height:30px;
		background:#0078FF;
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		color: #FFFFFF;
		border: none;
		font-size: 11px;
		cursor: pointer;
	} 
	.tablecontent li:nth-child(1)::before{
		border: none;
	}
	
	.tableHeader li:nth-child(1){
		width: 8%;
	}
	.tableHeader li:nth-child(2){
		width: 10%;
	}
	.tableHeader li:nth-child(3){
		width: 22%;
	}
	.tableHeader li:nth-child(4){
		width:  11%;
	}
	.tableHeader li:nth-child(5){
		width:11%;
	}
	.tablecontent>li:nth-child(5){
		padding-top: 45px;
		height: 92px;
		position: relative;
		text-align: left;
	}
	.tablecontent>li:nth-child(5)>p{
		cursor: pointer;
		font-size:11px;
		font-family:PingFangSC;
		font-weight:600;
		color:rgba(155,155,155,1);
		line-height: 25px;
		height: 25px;
		margin-left: 20px;
	}
	.tablecontent>li:nth-child(5)>p>i{
		color: rgba(0,120,255,1);
		margin-right: 5px;
	}
	.dialogImg{
		width:177px;
		height:130px;
		position: absolute;
		top: 100px;
		left: 0px;
		z-index:3;
		border: 1px solid #CCCCCC;
		border-radius: 5px;
		display: none;
	}
	.dialogImg>img{
		width:177px;
		height:130px;
	}
	.dialogImg>i{
		display: block;
		width: 20px;
		height: 20px;
		cursor: pointer;
		font-size:20px ;
		color: #000000;
		position: absolute;
		right: 10px;
		top: 10px;
	}
	.tableHeader li:nth-child(6){
		width: 8%;
	}
	.tableHeader li:nth-child(7){
		width: 10%;
	}
	.tableHeader li:nth-child(8){
		width: 20%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.dialog-jgfk{
		width: 100%;
		height: 100%;
		background: #FFFFFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 111;
	}
	.commtitle{
		height: 70px;
		width: 100%;
		line-height: 70px;
		font-weight: 600;
		font-size:18px;
		color: #9B9B9B;
		border-bottom: 2px solid rgba(119,151,178,0.16);
		/*box-shadow:0px 2px 2px 0px rgba(119,151,178,0.16);*/
	}
	.commtitle>.el-icon-arrow-left{
		font-weight:bold ;
		color:#2E3458 ;
		margin-left: 20px;
		margin-right: 13px;
	}
	.zdcontent{
		width:100%;
		height:719px;
		background:#F5F5F5;
		box-shadow:0px 0px 2px 0px rgba(119,151,178,0.16);
	}
	.list-more{
		width: 100%;
		height: 100px;
		line-height: 100px;
		text-align: center;
		font-size: 12px;
	}
</style>
<style>
	.el-dialog__wrapper .el-dialog--center .el-dialog__body{
		text-align: center;
	}
	.el-dialog__wrapper .el-dialog--center .el-dialog__body img{
		width: 800px !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/MA/clinicManagement/clinicProbate.vue